import React, { ReactNode } from 'react'
import { Box, CircularProgress, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { SettingTypeMasonryTile, SettingTypeMasonryTileIcon } from '../../styles/MasonryStyles'

interface SettingTileProps {
  icon: ReactNode
  title: string
  description: string
  onSelect: () => void
  isLoading?: boolean
}

const SettingTile: React.FC<SettingTileProps> = ({ icon, title, description, onSelect, isLoading }) => {
  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <SettingTypeMasonryTile
      elevation={0}
      onClick={!isLoading ? onSelect : undefined}
      tabIndex={0}
      onKeyDown={event => {
        if (!isLoading && event.key === 'Enter') {
          onSelect()
        }
      }}
      sx={{ position: 'relative' }}
    >
      <Stack direction={isDownSm ? 'column' : 'row'} sx={{ gap: isDownSm ? 1 : 2.5 }} alignItems="center">
        <SettingTypeMasonryTileIcon>{icon}</SettingTypeMasonryTileIcon>
        <Stack>
          <Typography
            fontWeight={700}
            sx={{ fontSize: 16, color: 'text.highEmphasis', textAlign: isDownSm ? 'center' : 'left' }}
          >
            {title}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontSize: 13,
              fontStyle: 'italic',
              color: 'text.mediumEmphasis',
              textAlign: isDownSm ? 'center' : 'left',
            }}
          >
            {description}
          </Typography>
        </Stack>
      </Stack>

      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(255, 255, 255, 0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
          }}
        >
          <CircularProgress size={32} />
        </Box>
      )}
    </SettingTypeMasonryTile>
  )
}

export default SettingTile
